import { resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, openBlock as _openBlock, createBlock as _createBlock, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_mini_wizard_manager = _resolveComponent("mini-wizard-manager")
  const _component_skeleton_mini_wizard = _resolveComponent("skeleton-mini-wizard")

  return ($options.isInitialized)
    ? (_openBlock(), _createBlock(_component_mini_wizard_manager, _normalizeProps(_mergeProps({ key: 0 }, $props.miniWizardModel)), null, 16 /* FULL_PROPS */))
    : (_openBlock(), _createBlock(_component_skeleton_mini_wizard, { key: 1 }))
}